<div class="component-container">
  <ng-container
    *ngComponentOutlet="
      components()[config().variant].component;
      inputs: components()[config().variant].inputs
    "
  />
  @if (challenge().isOutOfStock()) {
    <b2c-outofstock />
  }
</div>
